import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Document = ({
  size,
  type,
  theme,
  className,
  dataTestId = "document-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M5.3763 9.1849C5.00811 9.1849 4.70964 9.48337 4.70964 9.85156C4.70964 10.2198 5.00811 10.5182 5.3763 10.5182H10.623C10.9912 10.5182 11.2897 10.2198 11.2897 9.85156C11.2897 9.48337 10.9912 9.1849 10.623 9.1849H5.3763Z" />
    <path d="M4.70964 12.5182C4.70964 12.15 5.00811 11.8516 5.3763 11.8516H7.9627C8.33089 11.8516 8.62937 12.15 8.62937 12.5182C8.62937 12.8864 8.33089 13.1849 7.9627 13.1849H5.3763C5.00811 13.1849 4.70964 12.8864 4.70964 12.5182Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.07552 0.210938C2.33914 0.210938 1.74219 0.807893 1.74219 1.54427V14.6344C1.74219 15.3708 2.33914 15.9677 3.07552 15.9677H12.9236C13.66 15.9677 14.2569 15.3707 14.2569 14.6344V4.92666C14.2569 4.57304 14.1164 4.2339 13.8664 3.98385L10.484 0.601462C10.2339 0.351414 9.89481 0.210938 9.54118 0.210938H3.07552ZM3.07552 14.6344V1.54427L7.83594 1.54427V5.88629C7.83594 6.25448 8.13441 6.55296 8.5026 6.55296H12.9236V14.6344H3.07552ZM12.9236 5.21963V4.92666L9.54118 1.54427H9.16927V5.21963H12.9236Z"
    />
  </SVGIcon>
);
